import React, { useState } from "react";
import "./Commercial.css";
import Footer from "./Footer";
import img1 from "../assets/01-bedplate.jpg";
import img3 from "../assets/timing_chain-cover.jpg";
import img4 from "../assets/04-compressor-housing-assm.jpg";
import img2 from "../assets/Transmission-housing.jpg";

const products = [
     {
        title: "Front Cover",
        desc: "Protects components outside of engine from dust.",
        img: img1,
        type: "ICE",
        process: "HPDC",
        weight: "5.7 Kg",
        category: "Engine",
    },
    {
        title: "Air conditioning compressor housing",
        desc: "Air conditioning compressor housing assembly in passenger vehicles.",
        img: img4,
        type: "BEV",
        process: "HPDC",
        weight: "250 gms to 1.5 Kg",
        category: "Engine",
    },
    {
        title: "Transmission Housing",
        desc: "Houses gear assembly in transmission unit.",
        img: img2,
        type: "ICE",
        process: "HPDC",
        weight: "9 to 35 Kg",
        category: "Transmission",
    },
    {
        title: "Timing chain cover",
        desc: "Cover for timing chain.",
        img: img3,
        type: "ICE",
        process: "HPDC",
        weight: "11 to 12 Kg",
        category: "Transmission",
    },
];

function Passenger() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    const categories = [
        { key: "Engine", title: "Engine", desc:"Capability to manufacture a range of aluminium engine components through HPDC from 250 g to 6 kg. Below are just a few examples: " },
        { key: "Transmission", title: "Transmission" },
    ];

    return (
        <section id="pass">
            <div className="cv-container">
                <h2 className="cv-title">Passenger Vehicle</h2>
                <div className="cv-underline"></div>

                <p className="cv-desc">
                    In Passenger vehicles , We specialize in high-performance components for next-generation mobility. </p>

               {categories.map((category, catIndex) => (
    <div className="cv-category" key={category.key}>
        <h3 className="cv-category-title">
            {String(catIndex + 1).padStart(2, "0")}. {category.title}
        </h3>
                        {category.desc && (
                            <p className="cv-category-desc">
                                {category.desc}
                            </p>
                        )}

                        <div className="cv-grid">
                            {products
                                .filter(
                                    (item) =>
                                        item.category === category.key
                                )
                                .map((item, index) => (
                                    <div
                                        className="cv-card"
                                        key={index}
                                    >
                                        <div
                                            className="cv-image"
                                            style={
                                                item.img
                                                    ? {
                                                          backgroundImage: `url(${item.img})`,
                                                          backgroundSize:
                                                              "cover",
                                                          backgroundRepeat:
                                                              "no-repeat",
                                                          backgroundPosition:
                                                              "center",
                                                      }
                                                    : {}
                                            }
                                        />

                                        <div className="cv-overlay">
                                            <h4>{item.title}</h4>
                                            <p>{item.desc}</p>

                                            <span
                                                className="cv-link"
                                                onClick={() =>
                                                    setSelectedProduct(item)
                                                }
                                            >
                                                View Specifications ↗
                                            </span>
                                        </div>

                                        <div className="cv-label">
                                            {item.title}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                ))}

                {selectedProduct && (
                    <div
                        className="modal-backdrop"
                        onClick={() => setSelectedProduct(null)}
                    >
                        <div
                            className="modal-box"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <span
                                className="modal-close"
                                onClick={() =>
                                    setSelectedProduct(null)
                                }
                            >
                                ✕
                            </span>

                            <h5 className="modal-section-title">
                                Overview
                            </h5>

                            <div className="modal-overview">
                                <div
                                    className="modal-img"
                                    style={
                                        selectedProduct.img
                                            ? {
                                                  backgroundImage: `url(${selectedProduct.img})`,
                                                  backgroundSize: "cover",
                                                  backgroundRepeat:
                                                      "no-repeat",
                                                  backgroundPosition:
                                                      "center",
                                              }
                                            : {}
                                    }
                                ></div>

                                <div>
                                    <h3>
                                        {selectedProduct.title}
                                    </h3>
                                    <p>
                                        {selectedProduct.desc}
                                    </p>
                                </div>
                            </div>

                            <h5 className="modal-section-title">
                                Features
                            </h5>

                            <div className="modal-table">
                                <div>
                                    <span>
                                        ICE / BEV / Chasis / Cabin
                                    </span>
                                    <span>
                                        {selectedProduct.type}
                                    </span>
                                </div>

                                <div>
                                    <span>
                                        Casting Process Used
                                    </span>
                                    <span>
                                        {selectedProduct.process}
                                    </span>
                                </div>

                                <div>
                                    <span>Weight (Kg)</span>
                                    <span>
                                        {selectedProduct.weight}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <Footer />
        </section>
    );
}

export default Passenger;